import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { tokenStore } from './api/client';
import { useAuth } from './auth';
import Layout from './components/Layout';
import { Spinner } from './components/ui';
import Accounts from './pages/Accounts';
import Audit from './pages/Audit';
import BacktestDetail from './pages/BacktestDetail';
import Backtests from './pages/Backtests';
import Dashboard from './pages/Dashboard';
import DatasetDetail from './pages/DatasetDetail';
import Datasets from './pages/Datasets';
import Events from './pages/Events';
import JobDetail from './pages/JobDetail';
import Login from './pages/Login';
import ModelDetail from './pages/ModelDetail';
import Models from './pages/Models';
import Operations from './pages/Operations';
import PositionDetail from './pages/PositionDetail';
import Positions from './pages/Positions';
import Signals from './pages/Signals';
import Strategies from './pages/Strategies';
import StrategyDetail from './pages/StrategyDetail';

function ProtectedLayout() {
  const { user, isLoading } = useAuth();

  if (!tokenStore.access) return <Navigate to="/login" replace />;
  if (isLoading) return <Spinner label="Loading your session…" />;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/positions" element={<Positions />} />
        <Route path="/positions/:ticket" element={<PositionDetail />} />
        <Route path="/strategies" element={<Strategies />} />
        <Route path="/strategies/:id" element={<StrategyDetail />} />
        <Route path="/signals" element={<Signals />} />
        <Route path="/models" element={<Models />} />
        <Route path="/models/:id" element={<ModelDetail />} />
        <Route path="/datasets" element={<Datasets />} />
        <Route path="/datasets/:hash" element={<DatasetDetail />} />
        <Route path="/backtests" element={<Backtests />} />
        <Route path="/backtests/:id" element={<BacktestDetail />} />
        <Route path="/events" element={<Events />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/operations" element={<Operations />} />
        <Route path="/operations/jobs/:id" element={<JobDetail />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
